module.exports = __webpack_public_path__ + "static/media/invoiceOutgoing.3759f460.svg";